// SENTRY-FIX-001 + FIX-002: Judge.me jQuery + plugin dependency safety check
// Ensures Judge.me scripts don't execute until jQuery AND its plugins (raty, validate) are ready
// FIX-002: Added raty/validate plugin loading guards (2026-03-02)

(function() {
  'use strict';

  function isJQueryReady() {
    return typeof window.jQuery !== 'undefined' && typeof window.$ !== 'undefined';
  }

  function waitFor(conditionFn, callback, maxAttempts, interval) {
    maxAttempts = maxAttempts || 50;
    interval = interval || 100;
    var attempts = 0;
    var check = setInterval(function() {
      attempts++;
      if (conditionFn()) {
        clearInterval(check);
        callback(true);
      } else if (attempts >= maxAttempts) {
        clearInterval(check);
        callback(false);
      }
    }, interval);
  }

  // FIX-002: Patch Judge.me functions that depend on raty/validate plugins
  function patchJudgeMePluginDeps() {
    if (!isJQueryReady() || !window.jdgm) return;
    var $ = window.jQuery;

    // Guard _renderAndSetupReviewForm — depends on $.fn.raty
    if (window.jdgm._renderAndSetupReviewForm && !window.jdgm.__ratyGuardApplied) {
      var originalRender = window.jdgm._renderAndSetupReviewForm;
      window.jdgm._renderAndSetupReviewForm = function() {
        var args = arguments;
        var self = this;
        if ($.fn.raty) {
          return originalRender.apply(self, args);
        }
        console.warn('[SENTRY-FIX-002] Waiting for raty plugin before rendering review form');
        waitFor(
          function() { return !!$.fn.raty; },
          function(success) {
            if (success) {
              originalRender.apply(self, args);
            } else {
              console.error('[SENTRY-FIX-002] raty plugin failed to load after timeout');
            }
          },
          100, 100
        );
      };
      window.jdgm.__ratyGuardApplied = true;
    }

    // Guard setupReviewFormValidation — depends on $.fn.validate
    if (window.jdgm.setupReviewFormValidation && !window.jdgm.__validateGuardApplied) {
      var originalValidate = window.jdgm.setupReviewFormValidation;
      window.jdgm.setupReviewFormValidation = function() {
        var args = arguments;
        var self = this;
        if ($.fn.validate) {
          return originalValidate.apply(self, args);
        }
        console.warn('[SENTRY-FIX-002] Waiting for validate plugin before setting up form validation');
        waitFor(
          function() { return !!$.fn.validate; },
          function(success) {
            if (success) {
              originalValidate.apply(self, args);
            } else {
              console.error('[SENTRY-FIX-002] validate plugin failed to load after timeout');
            }
          },
          100, 100
        );
      };
      window.jdgm.__validateGuardApplied = true;
    }
  }

  // FIX-001: Wrap Judge.me initialization to wait for jQuery
  function applyJQueryGuard() {
    if (!window.jdgm || window.jdgm.__safetyCheckApplied) return;
    var originalInit = window.jdgm.init || function() {};
    window.jdgm.init = function() {
      var self = this;
      var args = arguments;
      if (isJQueryReady()) {
        patchJudgeMePluginDeps();
        return originalInit.apply(self, args);
      }
      console.warn('[SENTRY-FIX-001] Waiting for jQuery before Judge.me initialization');
      waitFor(isJQueryReady, function(success) {
        if (success) {
          patchJudgeMePluginDeps();
          originalInit.apply(self, args);
        }
      }, 50, 100);
    };
    window.jdgm.__safetyCheckApplied = true;
  }

  // Apply guards
  if (window.jdgm) {
    applyJQueryGuard();
    if (isJQueryReady()) patchJudgeMePluginDeps();
  }

  document.addEventListener('DOMContentLoaded', function() {
    if (window.jdgm) {
      applyJQueryGuard();
      patchJudgeMePluginDeps();
    }
  });

  // Watch for Judge.me script injection (loads dynamically)
  var observer = new MutationObserver(function() {
    if (window.jdgm && !window.jdgm.__ratyGuardApplied) {
      applyJQueryGuard();
      if (isJQueryReady()) patchJudgeMePluginDeps();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function() { observer.disconnect(); }, 15000);

  // Global error suppressor for plugin dependency errors
  window.addEventListener('error', function(event) {
    var msg = event.message || '';
    if (msg.includes('raty is not a function') ||
        msg.includes('validate is not a function') ||
        msg.includes('magnificPopup is not a function')) {
      console.warn('[SENTRY-FIX-002] Suppressed Judge.me plugin error:', msg);
      event.preventDefault();
      return true;
    }
    if ((msg.includes('jQuery') || msg.includes('jdgm.$') || msg.includes('unveil')) && !isJQueryReady()) {
      console.error('[SENTRY-FIX-001] jQuery dependency error:', msg);
      event.preventDefault();
      if (!window.__jqueryFallbackAttempted) {
        window.__jqueryFallbackAttempted = true;
        var s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js';
        s.async = false;
        document.head.appendChild(s);
      }
    }
  }, true);
})();
